import { GitCompare } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const RebaseIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '16px',
  ...rest
}) => <GitCompare width={size} height={size} color={color} {...rest} />;

RebaseIcon.displayName = 'RebaseIcon';

export default RebaseIcon;
